import script from "./file-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./file-message.vue?vue&type=script&lang=ts&setup=true"

import "./file-message.vue?vue&type=style&index=0&id=efd27b32&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd27b32"]])

export default __exports__